var map = {
	"./0x.svg": 296,
	"./CDAI.svg": 635,
	"./CETH.svg": 636,
	"./CUSDC.svg": 637,
	"./CWBTC.svg": 638,
	"./DAI.svg": 639,
	"./ETH.svg": 640,
	"./HackMoney.svg": 298,
	"./REP.svg": 641,
	"./SUSD.svg": 642,
	"./USDC.svg": 643,
	"./USDT.svg": 644,
	"./WBTC.svg": 645,
	"./WETH.svg": 646,
	"./aave.svg": 647,
	"./btc.svg": 648,
	"./buildeth.svg": 299,
	"./compound.svg": 295,
	"./curve.svg": 649,
	"./curve2.svg": 297,
	"./dxdy.svg": 650,
	"./fulcrum.svg": 651,
	"./goo.svg": 300,
	"./lab.svg": 126,
	"./mm.svg": 652,
	"./rdai.svg": 653,
	"./tokenset.svg": 654,
	"./uniswap.svg": 655,
	"./uniswapv2.svg": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;